// src/components/HourlyWelcomePopup.js
import React, { useState, useEffect } from 'react';
import { Modal, Button, Typography } from 'antd';
import { CheckOutlined, FireOutlined, ThunderboltOutlined, GiftOutlined, CloseOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const { Title, Text } = Typography;

const HourlyWelcomePopup = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [lastShowTime, setLastShowTime] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Vérifier si c'est un appareil mobile
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    const savedLastShowTime = localStorage.getItem('fifa_ea26_last_show_time');
    const currentTime = new Date().getTime();
    
    if (savedLastShowTime) {
      setLastShowTime(parseInt(savedLastShowTime));
      const timeSinceLastShow = currentTime - parseInt(savedLastShowTime);
      if (timeSinceLastShow >= 3600000) showPopup();
    } else {
      showPopup();
    }

    const interval = setInterval(() => {
      const currentTime = new Date().getTime();
      const savedTime = localStorage.getItem('fifa_ea26_last_show_time');
      if (savedTime && (currentTime - parseInt(savedTime)) >= 3600000) showPopup();
    }, 60000);

    return () => {
      clearInterval(interval);
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  const showPopup = () => {
    const timer = setTimeout(() => {
      setVisible(true);
      setTimeout(() => setIsVisible(true), 100);
      const currentTime = new Date().getTime();
      localStorage.setItem('fifa_ea26_last_show_time', currentTime.toString());
      setLastShowTime(currentTime);
    }, 3000);
    return () => clearTimeout(timer);
  };

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(() => setVisible(false), 500);
  };

  const handleDiscoverOffers = () => {
    handleClose();
    setTimeout(() => navigate('/collection'), 500);
  };

  const getNextShowTime = () => {
    const nextTime = lastShowTime + 3600000;
    return new Date(nextTime).toLocaleTimeString();
  };

  // Phrases commerciales traduites
  const commercialPhrases = [
    t('💎 ELITE OFFER: Comptes pros garantis 100% safe!'),
  ];
  const currentPhrase = commercialPhrases[Math.floor(Math.random() * commercialPhrases.length)];

  const features = [
    { icon: '🎯', title: t('PRIX CHOC'), desc: t('-40% sur les packs légendaires') },
    { icon: '⚡', title: t('LIVRAISON INSTANT'), desc: t('Comptes livrés en 2min max') },
    { icon: '🛡️', title: t('GARANTIE 100%'), desc: t('Sécurité absolue garantie') },
    { icon: '🎁', title: t('CADEAUX EXCLUSIFS'), desc: t('Bonus surprises inclus') }
  ];

  if (!visible) return null;

  return (
    <Modal
      open={visible}
      onCancel={handleClose}
      footer={null}
      centered
      width={isMobile ? 350 : 750}
      closable={false}
      maskClosable
      style={{ 
        top:  isMobile ? '15%':'60%', 
        transform: 'translateY(-50%)',
        maxWidth: '90vw'
      }}
      bodyStyle={{
        padding: isMobile ? '20px' : '40px',
        background: 'linear-gradient(135deg, #001489 0%, #0033a0 25%, #0056b3 50%, #007acc 75%, #0099e6 100%)',
        borderRadius: '20px',
        overflow: 'hidden',
        border: '3px solid #ffd700',
        boxShadow: '0 0 30px rgba(255, 215, 0, 0.4)',
        position: 'relative'
      }}
    >
      {/* Bouton X pour fermer */}
      <Button
        type="text"
        icon={<CloseOutlined />}
        onClick={handleClose}
        style={{
          position: 'absolute',
          top: isMobile ? '10px' : '15px',
          right: isMobile ? '10px' : '15px',
          zIndex: 10,
          color: '#ffd700',
          fontSize: isMobile ? '16px' : '18px',
          width: isMobile ? '30px' : '40px',
          height: isMobile ? '30px' : '40px',
          background: 'rgba(0, 0, 0, 0.3)',
          border: '1px solid #ffd700',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      />

      <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, zIndex: 1,
        background: `radial-gradient(circle at 20% 80%, rgba(255, 215, 0, 0.2) 0%, transparent 50%), radial-gradient(circle at 80% 20%, rgba(0, 255, 255, 0.2) 0%, transparent 50%), linear-gradient(45deg, rgba(0, 20, 137, 0.8) 0%, rgba(0, 51, 160, 0.8) 100%)`
      }}></div>

      <div style={{
        position: 'relative', 
        zIndex: 3, 
        padding: isMobile ? '10px 0' : '40px', 
        textAlign: 'center',
        color: 'white', 
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
        transition: 'all 0.8s ease-out',
      }}>
        <div style={{
          background: 'linear-gradient(90deg, #ff6b00, #ffd700)',
          padding: isMobile ? '8px 12px' : '12px 20px', 
          borderRadius: '25px', 
          marginBottom: isMobile ? '15px' : '25px',
          animation: 'glow 2s infinite alternate'
        }}>
          <Text strong style={{ 
            color: '#001489', 
            fontSize: isMobile ? '0.8rem' : '1.1rem', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center', 
            gap: isMobile ? '5px' : '10px'
          }}>
            <FireOutlined /> {currentPhrase} <FireOutlined />
          </Text>
        </div>

        <Title level={1} style={{ 
          color: '#ffd700', 
          marginBottom: isMobile ? '10px' : '15px', 
          fontWeight: 'bold', 
          textShadow: '3px 3px 10px rgba(0,0,0,0.8)', 
          fontSize: isMobile ? '1.3rem' : '2.2rem' 
        }}>
          {t('🚀 FIFA EA SPORTS 26 ! 🚀')}
        </Title>

        <Text style={{ 
          fontSize: isMobile ? '0.9rem' : '1.3rem', 
          display: 'block', 
          marginBottom: isMobile ? '8px' : '10px', 
          color: '#00ffff', 
          fontWeight: 'bold', 
          textShadow: '2px 2px 6px rgba(0,0,0,0.6)' 
        }}>
          <ThunderboltOutlined /> {t('LA RÉVOLUTION ULTIME !')} <ThunderboltOutlined />
        </Text>

        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(auto-fit, minmax(250px, 1fr))', 
          gap: isMobile ? '10px' : '20px', 
          margin: isMobile ? '15px 0' : '30px 0' 
        }}>
          {features.map((item, index) => (
            <div key={index} style={{ 
              background: 'rgba(255, 255, 255, 0.1)', 
              padding: isMobile ? '12px 8px' : '20px', 
              borderRadius: '15px', 
              border: '2px solid rgba(255, 215, 0, 0.3)', 
              textAlign: 'center', 
              opacity: isVisible ? 1 : 0, 
              transform: isVisible ? 'scale(1)' : 'scale(0.8)', 
              transition: `all 0.6s ease-out ${index * 0.1}s` 
            }}>
              <div style={{ fontSize: isMobile ? '1.5rem' : '2rem', marginBottom: isMobile ? '5px' : '10px' }}>
                {item.icon}
              </div>
              <Text strong style={{ 
                color: '#ffd700', 
                display: 'block', 
                fontSize: isMobile ? '0.8rem' : '1.1rem' 
              }}>
                {item.title}
              </Text>
            </div>
          ))}
        </div>

        <Button 
          type="primary" 
          icon={<CheckOutlined />} 
          onClick={handleDiscoverOffers} 
          size={isMobile ? "middle" : "large"}
          style={{ 
            background: 'linear-gradient(45deg, #ff6b00, #ffd700, #ff6b00)', 
            backgroundSize: '200% auto', 
            border: 'none', 
            fontWeight: 'bold', 
            padding: isMobile ? '10px 20px' : '15px 40px', 
            fontSize: isMobile ? '0.9rem' : '1.2rem', 
            borderRadius: '30px', 
            margin: isMobile ? '10px 0' : '15px 0', 
            boxShadow: '0 6px 20px rgba(255,107,0,0.6)', 
            animation: 'gradientShift 3s infinite', 
            transition: 'all 0.3s ease' 
          }}
          onMouseEnter={e => { 
            e.target.style.transform = 'scale(1.05)'; 
            e.target.style.boxShadow = '0 8px 25px rgba(255,107,0,0.8)'; 
          }}
          onMouseLeave={e => { 
            e.target.style.transform = 'scale(1)'; 
            e.target.style.boxShadow = '0 6px 20px rgba(255,107,0,0.6)'; 
          }}
        >
          {t('🚀 OFFRES EXCLUSIVES !')}
        </Button> 

        <Text style={{ 
          display: 'block', 
          marginTop: isMobile ? '10px' : '20px', 
          color: '#ffffff99', 
          fontSize: isMobile ? '0.7rem' : '0.9rem', 
          fontStyle: 'italic' 
        }}>
          {t('⚡ Joueurs satisfaits !')}
        </Text>
      </div>

      <style>{`
        @keyframes glow {
          0% { box-shadow: 0 0 10px rgba(255,107,0,0.4); }
          100% { box-shadow: 0 0 20px rgba(255,215,0,0.8); }
        }
        @keyframes gradientShift {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
    </Modal>
  );
};

export default HourlyWelcomePopup;